import { createContext as n, use as t } from "react";
import { jsx as o } from "react/jsx-runtime";
var e = n(null);
e.displayName = "AdminApiContext";
var p = ({ children: r, ...i }) => /* @__PURE__ */ o(e, {
  value: { ...i },
  children: r
}), d = () => {
  const r = t(e);
  if (!r) throw new Error("useAdminApi Hook must be used within an AdminApiProvider");
  return { server: r.server };
};
export {
  p as AdminApiProvider,
  d as useAdminApi
};

//# sourceMappingURL=AdminApiProvider.js.map